import * as React from 'react';
import { Box } from 'braid-design-system';
import CreateBrandButton from './Controls/CreateBrandButton';

import * as styles from './AddBrandPanel.css';

const AddBrandPanel = () => (
  <Box borderRadius="standard" className={styles.add}>
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="full"
    >
      <CreateBrandButton variant="ghost" />
    </Box>
  </Box>
);

export default AddBrandPanel;
